<template>
    <div>
        <div class="flex mt-4 justify-between gap-4">
            <div class="table__search-input-wrapper">
                <span class="pr-2 opacity-50"><search-icon /> </span>
                <input
                    type="text"
                    class="table__search-input"
                    placeholder="Search..."
                    v-model="querySearch"
                />
                <img src="@/assets/images/icons/search.svg" alt="search icon" />
            </div> 
            <base-button text="New Account"  @click="showAddCollectionModal = true"/>
        </div>

        <table class="custom-table mt-8 w-100">
             <thead>
                 <tr>
                     <th>Account Name</th>
                     <th>Bank Name</th>
                     <th>Account Number</th>
                     <th></th>
                 </tr>
             </thead>
             <tbody>
                 <tr>
                     <td>
                        Scello Limited
                        <p>Wema bank</p>
                     </td>
                     <td>0.020</td>
                     <td>0.020</td>
                     <td>
                         <span>
                             <svg width="18" height="5" viewBox="0 0 18 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2 4.5C0.89543 4.5 0 3.60457 0 2.5C0 1.39543 0.89543 0.5 2 0.5C3.10457 0.5 4 1.39543 4 2.5C4 3.60457 3.10457 4.5 2 4.5ZM9 4.5C7.89543 4.5 7 3.60457 7 2.5C7 1.39543 7.89543 0.5 9 0.5C10.1046 0.5 11 1.39543 11 2.5C11 3.60457 10.1046 4.5 9 4.5ZM14 2.5C14 3.60457 14.8954 4.5 16 4.5C17.1046 4.5 18 3.60457 18 2.5C18 1.39543 17.1046 0.5 16 0.5C14.8954 0.5 14 1.39543 14 2.5Z" fill="#10233E"/>
                            </svg>
                         </span>
                     </td>
                 </tr>
             </tbody>
        </table>
        <hr>
        <div class="flex justify-between">
            <p class="cursor-pointer ">Cancel</p>
            <base-button text="Save" />
        </div>
        <add-collection-modal :showModal="showAddCollectionModal" @close-modal="showAddCollectionModal = false"/>
    </div>
</template>

<script>
import AddCollectionModal from "../Modals/AddCollectionModal"

export default{
    components:{
        AddCollectionModal
    },
    data(){
        return {
            querySearch: '',
            showAddCollectionModal: false
        }
    }
}
</script>

<style lang="scss">


</style>